{
    "Ts89L9YagFBFf2zry_exw": {
        "key": "Ts89L9YagFBFf2zry_exw",
        "position": {
            "x": 22,
            "y": 12,
            "z": 1
        },
        "tag": "enemy1-spawn"
    },
    "uLQJE_W-r62Pm9iS0Qtcu": {
        "key": "uLQJE_W-r62Pm9iS0Qtcu",
        "position": {
            "x": 21,
            "y": 12,
            "z": 1
        },
        "tag": "enemy1-spawn"
    },
    "5MPyif27XhfLNIM2A6sh5": {
        "key": "5MPyif27XhfLNIM2A6sh5",
        "position": {
            "x": 20,
            "y": 12,
            "z": 1
        },
        "tag": "enemy1-spawn"
    },
    "wapbm1AojmC0zaxSQMllq": {
        "key": "wapbm1AojmC0zaxSQMllq",
        "position": {
            "x": 23,
            "y": 12,
            "z": 1
        },
        "tag": "enemy1-spawn"
    },
    "9NFaltLZkf9yBH_BD4nuP": {
        "key": "9NFaltLZkf9yBH_BD4nuP",
        "position": {
            "x": 15,
            "y": 8,
            "z": 1
        },
        "tag": "enemy1-spawn"
    },
    "pctGgWCzZdREmZZifqPiv": {
        "key": "pctGgWCzZdREmZZifqPiv",
        "position": {
            "x": 14,
            "y": 8,
            "z": 1
        },
        "tag": "enemy1-spawn"
    },
    "35bkiAJ8oOlPVkA1Shjeb": {
        "key": "35bkiAJ8oOlPVkA1Shjeb",
        "position": {
            "x": 13,
            "y": 8,
            "z": 1
        },
        "tag": "enemy1-spawn"
    },
    "kuKEdX9Lm7AmVYI-U0JDF": {
        "key": "kuKEdX9Lm7AmVYI-U0JDF",
        "position": {
            "x": 16,
            "y": 8,
            "z": 1
        },
        "tag": "enemy1-spawn"
    },
    "T-5fxxxVIqNpmt6pyD0JJ": {
        "key": "T-5fxxxVIqNpmt6pyD0JJ",
        "position": {
            "x": 8,
            "y": 12,
            "z": 1
        },
        "tag": "enemy1-spawn"
    },
    "OQenGZK8A9dXJKxqxuqZb": {
        "key": "OQenGZK8A9dXJKxqxuqZb",
        "position": {
            "x": 7,
            "y": 12,
            "z": 1
        },
        "tag": "enemy1-spawn"
    },
    "SHyb6-pqvLQfug9QdeLmS": {
        "key": "SHyb6-pqvLQfug9QdeLmS",
        "position": {
            "x": 6,
            "y": 12,
            "z": 1
        },
        "tag": "enemy1-spawn"
    },
    "QNUOD6P5zIJb_8-TKL6sJ": {
        "key": "QNUOD6P5zIJb_8-TKL6sJ",
        "position": {
            "x": 9,
            "y": 12,
            "z": 1
        },
        "tag": "enemy1-spawn"
    },
    "_RwVb9ASbJ7C8KAOo6Bqw": {
        "key": "_RwVb9ASbJ7C8KAOo6Bqw",
        "position": {
            "x": 20,
            "y": 18,
            "z": 1
        },
        "tag": "enemy2-spawn"
    },
    "F-OEblRTRzZSNys8bO4Pl": {
        "key": "F-OEblRTRzZSNys8bO4Pl",
        "position": {
            "x": 22,
            "y": 18,
            "z": 1
        },
        "tag": "enemy2-spawn"
    },
    "hZs9jhD5gWuqOpk5ztfWH": {
        "key": "hZs9jhD5gWuqOpk5ztfWH",
        "position": {
            "x": 21,
            "y": 18,
            "z": 1
        },
        "tag": "enemy2-spawn"
    },
    "FC88mgBXkKvRZSbGy7H7K": {
        "key": "FC88mgBXkKvRZSbGy7H7K",
        "position": {
            "x": 23,
            "y": 18,
            "z": 1
        },
        "tag": "enemy2-spawn"
    },
    "t5IT3H5JSb6ap7I_OGi1i": {
        "key": "t5IT3H5JSb6ap7I_OGi1i",
        "position": {
            "x": 13,
            "y": 14,
            "z": 1
        },
        "tag": "enemy2-spawn"
    },
    "T9ssR28TjJ-ykfjk08yJl": {
        "key": "T9ssR28TjJ-ykfjk08yJl",
        "position": {
            "x": 15,
            "y": 14,
            "z": 1
        },
        "tag": "enemy2-spawn"
    },
    "HmaATnmVi9elUCAfTi6IR": {
        "key": "HmaATnmVi9elUCAfTi6IR",
        "position": {
            "x": 14,
            "y": 14,
            "z": 1
        },
        "tag": "enemy2-spawn"
    },
    "NTk7X6bM4imwkMtNqb5wR": {
        "key": "NTk7X6bM4imwkMtNqb5wR",
        "position": {
            "x": 16,
            "y": 14,
            "z": 1
        },
        "tag": "enemy2-spawn"
    },
    "9HjsaiAdkg605FUF2VQqp": {
        "key": "9HjsaiAdkg605FUF2VQqp",
        "position": {
            "x": 6,
            "y": 18,
            "z": 1
        },
        "tag": "enemy2-spawn"
    },
    "4mqBcgZ8r1yylLNL5EzTl": {
        "key": "4mqBcgZ8r1yylLNL5EzTl",
        "position": {
            "x": 8,
            "y": 18,
            "z": 1
        },
        "tag": "enemy2-spawn"
    },
    "3hrPE-oO5BPui3cj7tNel": {
        "key": "3hrPE-oO5BPui3cj7tNel",
        "position": {
            "x": 7,
            "y": 18,
            "z": 1
        },
        "tag": "enemy2-spawn"
    },
    "KFwTeJoFKTnH6-OpFlQNF": {
        "key": "KFwTeJoFKTnH6-OpFlQNF",
        "position": {
            "x": 9,
            "y": 18,
            "z": 1
        },
        "tag": "enemy2-spawn"
    },
    "ANgDsaMKeO8wm1cjN4l9Y": {
        "key": "ANgDsaMKeO8wm1cjN4l9Y",
        "position": {
            "x": 24,
            "y": 16,
            "z": 1
        },
        "tag": "player-spawn"
    },
    "EypXwXcytzm3OHIvMV0Cp": {
        "key": "EypXwXcytzm3OHIvMV0Cp",
        "position": {
            "x": 24,
            "y": 14,
            "z": 1
        },
        "tag": "player-spawn"
    },
    "caaQtHrMJGXdtc600Tg_h": {
        "key": "caaQtHrMJGXdtc600Tg_h",
        "position": {
            "x": 24,
            "y": 15,
            "z": 1
        },
        "tag": "player-spawn"
    },
    "7bzrxiGQcG8MLho1X6sVY": {
        "key": "7bzrxiGQcG8MLho1X6sVY",
        "position": {
            "x": 17,
            "y": 12,
            "z": 1
        },
        "tag": "player-spawn"
    },
    "jB6BIxeqRBUPclVSdGZDO": {
        "key": "jB6BIxeqRBUPclVSdGZDO",
        "position": {
            "x": 17,
            "y": 10,
            "z": 1
        },
        "tag": "player-spawn"
    },
    "thkG5ys7rXA-EChRsxgD_": {
        "key": "thkG5ys7rXA-EChRsxgD_",
        "position": {
            "x": 17,
            "y": 11,
            "z": 1
        },
        "tag": "player-spawn"
    },
    "orJqY_BAMbBY86PtlmXCJ": {
        "key": "orJqY_BAMbBY86PtlmXCJ",
        "position": {
            "x": 10,
            "y": 16,
            "z": 1
        },
        "tag": "player-spawn"
    },
    "NAj7mrLzlZlguOLHGgaa4": {
        "key": "NAj7mrLzlZlguOLHGgaa4",
        "position": {
            "x": 10,
            "y": 14,
            "z": 1
        },
        "tag": "player-spawn"
    },
    "S28kewhXgYjGPlKwBs7Ct": {
        "key": "S28kewhXgYjGPlKwBs7Ct",
        "position": {
            "x": 10,
            "y": 15,
            "z": 1
        },
        "tag": "player-spawn"
    },
    "SR4C2qzQc-jU_9PSlAj4d": {
        "key": "SR4C2qzQc-jU_9PSlAj4d",
        "position": {
            "x": 19,
            "y": 14,
            "z": 1
        },
        "tag": "player-exit",
        "isVisible": true
    },
    "bzNQvlueyULXSCG6EZU0a": {
        "key": "bzNQvlueyULXSCG6EZU0a",
        "position": {
            "x": 19,
            "y": 15,
            "z": 1
        },
        "tag": "player-exit",
        "isVisible": true
    },
    "01egLpZRRzKAOESl8Vhyn": {
        "key": "01egLpZRRzKAOESl8Vhyn",
        "position": {
            "x": 19,
            "y": 16,
            "z": 1
        },
        "tag": "player-exit",
        "isVisible": true
    },
    "EXnRbwCyqoqllFDgRzXNK": {
        "key": "EXnRbwCyqoqllFDgRzXNK",
        "position": {
            "x": 12,
            "y": 10,
            "z": 1
        },
        "tag": "player-exit",
        "isVisible": true
    },
    "k3kxFTk1v2z9nIolMmu9T": {
        "key": "k3kxFTk1v2z9nIolMmu9T",
        "position": {
            "x": 12,
            "y": 11,
            "z": 1
        },
        "tag": "player-exit",
        "isVisible": true
    },
    "rn4G2ot4GIoS7K19sEyrb": {
        "key": "rn4G2ot4GIoS7K19sEyrb",
        "position": {
            "x": 12,
            "y": 12,
            "z": 1
        },
        "tag": "player-exit",
        "isVisible": true
    },
    "b8vIzCnCBGomlaZA8GaMI": {
        "key": "b8vIzCnCBGomlaZA8GaMI",
        "position": {
            "x": 5,
            "y": 14,
            "z": 1
        },
        "tag": "player-exit",
        "isVisible": true
    },
    "cGHt5q0xYMvCOlfbo3d97": {
        "key": "cGHt5q0xYMvCOlfbo3d97",
        "position": {
            "x": 5,
            "y": 15,
            "z": 1
        },
        "tag": "player-exit",
        "isVisible": true
    },
    "aJoaFwcedaw-jLSCVdiF3": {
        "key": "aJoaFwcedaw-jLSCVdiF3",
        "position": {
            "x": 5,
            "y": 16,
            "z": 1
        },
        "tag": "player-exit",
        "isVisible": true
    }
}
